export type SensorCause = {
  cause: string;
  probability: number;
};

export type SensorFault = {
  id: string;
  category_id: string | null;
  device_ar: string;
  name_ar: string;
  description_ar: string;
  symptoms: string[];
  causes: SensorCause[];
  tests: {
    test: string;
    location: string;
    method: string;
    normal: string;
    faulty: string;
  }[];
  solutions: string[];
  severity: string;
  safety_warnings: string[];
  error_code: string | null;
  keywords: string;
  next_question_key: string | null;
};

type Row = [
  string,
  string,
  string,
  string,
  string,
  SensorCause[],
  string[],
  string,
  string
];

const C = (cause: string, probability: number): SensorCause => ({
  cause,
  probability,
});

const rows: Row[] = [
[
  "sensor-001",
  "Inductive Proximity Sensor",
  "Inductive Proximity Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Inductive Proximity Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Inductive Proximity Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors inductive proximity not working open",
],
[
  "sensor-002",
  "Inductive Proximity Sensor",
  "حرارة Inductive Proximity Sensor ترتفع",
  "حرارة Inductive Proximity Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Inductive Proximity Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors inductive proximity overheating hot",
],
[
  "sensor-003",
  "Inductive Proximity Sensor",
  "Inductive Proximity Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Inductive Proximity Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors inductive proximity intermittent unstable",
],
[
  "sensor-004",
  "Inductive Proximity Sensor",
  "Inductive Proximity Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Inductive Proximity Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors inductive proximity loose wrong connection",
],
[
  "sensor-005",
  "Inductive Proximity Sensor",
  "قراءة أو خرج Inductive Proximity Sensor مو طبيعي",
  "قراءة أو خرج Inductive Proximity Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors inductive proximity abnormal reading output",
],
[
  "sensor-006",
  "Capacitive Proximity Sensor",
  "Capacitive Proximity Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Capacitive Proximity Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Capacitive Proximity Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors capacitive proximity not working open",
],
[
  "sensor-007",
  "Capacitive Proximity Sensor",
  "حرارة Capacitive Proximity Sensor ترتفع",
  "حرارة Capacitive Proximity Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Capacitive Proximity Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors capacitive proximity overheating hot",
],
[
  "sensor-008",
  "Capacitive Proximity Sensor",
  "Capacitive Proximity Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Capacitive Proximity Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors capacitive proximity intermittent unstable",
],
[
  "sensor-009",
  "Capacitive Proximity Sensor",
  "Capacitive Proximity Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Capacitive Proximity Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors capacitive proximity loose wrong connection",
],
[
  "sensor-010",
  "Capacitive Proximity Sensor",
  "قراءة أو خرج Capacitive Proximity Sensor مو طبيعي",
  "قراءة أو خرج Capacitive Proximity Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors capacitive proximity abnormal reading output",
],
[
  "sensor-011",
  "Photoelectric Sensor",
  "Photoelectric Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Photoelectric Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Photoelectric Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors photoelectric not working open",
],
[
  "sensor-012",
  "Photoelectric Sensor",
  "حرارة Photoelectric Sensor ترتفع",
  "حرارة Photoelectric Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Photoelectric Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors photoelectric overheating hot",
],
[
  "sensor-013",
  "Photoelectric Sensor",
  "Photoelectric Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Photoelectric Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors photoelectric intermittent unstable",
],
[
  "sensor-014",
  "Photoelectric Sensor",
  "Photoelectric Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Photoelectric Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors photoelectric loose wrong connection",
],
[
  "sensor-015",
  "Photoelectric Sensor",
  "قراءة أو خرج Photoelectric Sensor مو طبيعي",
  "قراءة أو خرج Photoelectric Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors photoelectric abnormal reading output",
],
[
  "sensor-016",
  "Ultrasonic Sensor",
  "Ultrasonic Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Ultrasonic Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Ultrasonic Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors ultrasonic not working open",
],
[
  "sensor-017",
  "Ultrasonic Sensor",
  "حرارة Ultrasonic Sensor ترتفع",
  "حرارة Ultrasonic Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Ultrasonic Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors ultrasonic overheating hot",
],
[
  "sensor-018",
  "Ultrasonic Sensor",
  "Ultrasonic Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Ultrasonic Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors ultrasonic intermittent unstable",
],
[
  "sensor-019",
  "Ultrasonic Sensor",
  "Ultrasonic Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Ultrasonic Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors ultrasonic loose wrong connection",
],
[
  "sensor-020",
  "Ultrasonic Sensor",
  "قراءة أو خرج Ultrasonic Sensor مو طبيعي",
  "قراءة أو خرج Ultrasonic Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors ultrasonic abnormal reading output",
],
[
  "sensor-021",
  "Pressure Transmitter 4-20mA",
  "Pressure Transmitter 4-20mA ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Pressure Transmitter 4-20mA متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Pressure Transmitter 4-20mA",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors pressure transmitter not working open",
],
[
  "sensor-022",
  "Pressure Transmitter 4-20mA",
  "حرارة Pressure Transmitter 4-20mA ترتفع",
  "حرارة Pressure Transmitter 4-20mA أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Pressure Transmitter 4-20mA",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors pressure transmitter overheating hot",
],
[
  "sensor-023",
  "Pressure Transmitter 4-20mA",
  "Pressure Transmitter 4-20mA يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Pressure Transmitter 4-20mA تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors pressure transmitter intermittent unstable",
],
[
  "sensor-024",
  "Pressure Transmitter 4-20mA",
  "Pressure Transmitter 4-20mA بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Pressure Transmitter 4-20mA.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors pressure transmitter loose wrong connection",
],
[
  "sensor-025",
  "Pressure Transmitter 4-20mA",
  "قراءة أو خرج Pressure Transmitter 4-20mA مو طبيعي",
  "قراءة أو خرج Pressure Transmitter 4-20mA أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors pressure transmitter abnormal reading output",
],
[
  "sensor-026",
  "Pressure Switch",
  "Pressure Switch ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Pressure Switch متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Pressure Switch",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors pressure switch not working open",
],
[
  "sensor-027",
  "Pressure Switch",
  "حرارة Pressure Switch ترتفع",
  "حرارة Pressure Switch أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Pressure Switch",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors pressure switch overheating hot",
],
[
  "sensor-028",
  "Pressure Switch",
  "Pressure Switch يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Pressure Switch تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors pressure switch intermittent unstable",
],
[
  "sensor-029",
  "Pressure Switch",
  "Pressure Switch بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Pressure Switch.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors pressure switch loose wrong connection",
],
[
  "sensor-030",
  "Pressure Switch",
  "قراءة أو خرج Pressure Switch مو طبيعي",
  "قراءة أو خرج Pressure Switch أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors pressure switch abnormal reading output",
],
[
  "sensor-031",
  "RTD PT100",
  "RTD PT100 ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة RTD PT100 متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة RTD PT100",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors rtd pt100 not working open",
],
[
  "sensor-032",
  "RTD PT100",
  "حرارة RTD PT100 ترتفع",
  "حرارة RTD PT100 أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة RTD PT100",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors rtd pt100 overheating hot",
],
[
  "sensor-033",
  "RTD PT100",
  "RTD PT100 يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة RTD PT100 تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors rtd pt100 intermittent unstable",
],
[
  "sensor-034",
  "RTD PT100",
  "RTD PT100 بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ RTD PT100.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors rtd pt100 loose wrong connection",
],
[
  "sensor-035",
  "RTD PT100",
  "قراءة أو خرج RTD PT100 مو طبيعي",
  "قراءة أو خرج RTD PT100 أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors rtd pt100 abnormal reading output",
],
[
  "sensor-036",
  "Thermocouple",
  "Thermocouple ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Thermocouple متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Thermocouple",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors thermocouple not working open",
],
[
  "sensor-037",
  "Thermocouple",
  "حرارة Thermocouple ترتفع",
  "حرارة Thermocouple أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Thermocouple",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors thermocouple overheating hot",
],
[
  "sensor-038",
  "Thermocouple",
  "Thermocouple يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Thermocouple تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors thermocouple intermittent unstable",
],
[
  "sensor-039",
  "Thermocouple",
  "Thermocouple بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Thermocouple.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors thermocouple loose wrong connection",
],
[
  "sensor-040",
  "Thermocouple",
  "قراءة أو خرج Thermocouple مو طبيعي",
  "قراءة أو خرج Thermocouple أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors thermocouple abnormal reading output",
],
[
  "sensor-041",
  "Thermostat",
  "Thermostat ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Thermostat متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Thermostat",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors thermostat not working open",
],
[
  "sensor-042",
  "Thermostat",
  "حرارة Thermostat ترتفع",
  "حرارة Thermostat أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Thermostat",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors thermostat overheating hot",
],
[
  "sensor-043",
  "Thermostat",
  "Thermostat يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Thermostat تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors thermostat intermittent unstable",
],
[
  "sensor-044",
  "Thermostat",
  "Thermostat بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Thermostat.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors thermostat loose wrong connection",
],
[
  "sensor-045",
  "Thermostat",
  "قراءة أو خرج Thermostat مو طبيعي",
  "قراءة أو خرج Thermostat أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors thermostat abnormal reading output",
],
[
  "sensor-046",
  "Float Switch",
  "Float Switch ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Float Switch متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Float Switch",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors float switch not working open",
],
[
  "sensor-047",
  "Float Switch",
  "حرارة Float Switch ترتفع",
  "حرارة Float Switch أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Float Switch",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors float switch overheating hot",
],
[
  "sensor-048",
  "Float Switch",
  "Float Switch يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Float Switch تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors float switch intermittent unstable",
],
[
  "sensor-049",
  "Float Switch",
  "Float Switch بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Float Switch.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors float switch loose wrong connection",
],
[
  "sensor-050",
  "Float Switch",
  "قراءة أو خرج Float Switch مو طبيعي",
  "قراءة أو خرج Float Switch أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors float switch abnormal reading output",
],
[
  "sensor-051",
  "Level Transmitter",
  "Level Transmitter ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Level Transmitter متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Level Transmitter",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors level transmitter not working open",
],
[
  "sensor-052",
  "Level Transmitter",
  "حرارة Level Transmitter ترتفع",
  "حرارة Level Transmitter أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Level Transmitter",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors level transmitter overheating hot",
],
[
  "sensor-053",
  "Level Transmitter",
  "Level Transmitter يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Level Transmitter تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors level transmitter intermittent unstable",
],
[
  "sensor-054",
  "Level Transmitter",
  "Level Transmitter بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Level Transmitter.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors level transmitter loose wrong connection",
],
[
  "sensor-055",
  "Level Transmitter",
  "قراءة أو خرج Level Transmitter مو طبيعي",
  "قراءة أو خرج Level Transmitter أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors level transmitter abnormal reading output",
],
[
  "sensor-056",
  "Flow Switch",
  "Flow Switch ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Flow Switch متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Flow Switch",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors flow switch not working open",
],
[
  "sensor-057",
  "Flow Switch",
  "حرارة Flow Switch ترتفع",
  "حرارة Flow Switch أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Flow Switch",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors flow switch overheating hot",
],
[
  "sensor-058",
  "Flow Switch",
  "Flow Switch يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Flow Switch تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors flow switch intermittent unstable",
],
[
  "sensor-059",
  "Flow Switch",
  "Flow Switch بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Flow Switch.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors flow switch loose wrong connection",
],
[
  "sensor-060",
  "Flow Switch",
  "قراءة أو خرج Flow Switch مو طبيعي",
  "قراءة أو خرج Flow Switch أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors flow switch abnormal reading output",
],
[
  "sensor-061",
  "Flow Transmitter",
  "Flow Transmitter ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Flow Transmitter متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Flow Transmitter",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors flow transmitter not working open",
],
[
  "sensor-062",
  "Flow Transmitter",
  "حرارة Flow Transmitter ترتفع",
  "حرارة Flow Transmitter أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Flow Transmitter",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors flow transmitter overheating hot",
],
[
  "sensor-063",
  "Flow Transmitter",
  "Flow Transmitter يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Flow Transmitter تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors flow transmitter intermittent unstable",
],
[
  "sensor-064",
  "Flow Transmitter",
  "Flow Transmitter بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Flow Transmitter.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors flow transmitter loose wrong connection",
],
[
  "sensor-065",
  "Flow Transmitter",
  "قراءة أو خرج Flow Transmitter مو طبيعي",
  "قراءة أو خرج Flow Transmitter أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors flow transmitter abnormal reading output",
],
[
  "sensor-066",
  "Encoder",
  "Encoder ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Encoder متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Encoder",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors encoder not working open",
],
[
  "sensor-067",
  "Encoder",
  "حرارة Encoder ترتفع",
  "حرارة Encoder أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Encoder",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors encoder overheating hot",
],
[
  "sensor-068",
  "Encoder",
  "Encoder يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Encoder تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors encoder intermittent unstable",
],
[
  "sensor-069",
  "Encoder",
  "Encoder بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Encoder.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors encoder loose wrong connection",
],
[
  "sensor-070",
  "Encoder",
  "قراءة أو خرج Encoder مو طبيعي",
  "قراءة أو خرج Encoder أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors encoder abnormal reading output",
],
[
  "sensor-071",
  "Load Cell",
  "Load Cell ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Load Cell متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Load Cell",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors load cell not working open",
],
[
  "sensor-072",
  "Load Cell",
  "حرارة Load Cell ترتفع",
  "حرارة Load Cell أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Load Cell",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors load cell overheating hot",
],
[
  "sensor-073",
  "Load Cell",
  "Load Cell يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Load Cell تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors load cell intermittent unstable",
],
[
  "sensor-074",
  "Load Cell",
  "Load Cell بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Load Cell.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors load cell loose wrong connection",
],
[
  "sensor-075",
  "Load Cell",
  "قراءة أو خرج Load Cell مو طبيعي",
  "قراءة أو خرج Load Cell أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors load cell abnormal reading output",
],
[
  "sensor-076",
  "Current Transducer",
  "Current Transducer ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Current Transducer متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Current Transducer",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors current sensor not working open",
],
[
  "sensor-077",
  "Current Transducer",
  "حرارة Current Transducer ترتفع",
  "حرارة Current Transducer أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Current Transducer",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors current sensor overheating hot",
],
[
  "sensor-078",
  "Current Transducer",
  "Current Transducer يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Current Transducer تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors current sensor intermittent unstable",
],
[
  "sensor-079",
  "Current Transducer",
  "Current Transducer بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Current Transducer.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors current sensor loose wrong connection",
],
[
  "sensor-080",
  "Current Transducer",
  "قراءة أو خرج Current Transducer مو طبيعي",
  "قراءة أو خرج Current Transducer أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors current sensor abnormal reading output",
],
[
  "sensor-081",
  "Voltage Transducer",
  "Voltage Transducer ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Voltage Transducer متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Voltage Transducer",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors voltage sensor not working open",
],
[
  "sensor-082",
  "Voltage Transducer",
  "حرارة Voltage Transducer ترتفع",
  "حرارة Voltage Transducer أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Voltage Transducer",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors voltage sensor overheating hot",
],
[
  "sensor-083",
  "Voltage Transducer",
  "Voltage Transducer يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Voltage Transducer تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors voltage sensor intermittent unstable",
],
[
  "sensor-084",
  "Voltage Transducer",
  "Voltage Transducer بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Voltage Transducer.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors voltage sensor loose wrong connection",
],
[
  "sensor-085",
  "Voltage Transducer",
  "قراءة أو خرج Voltage Transducer مو طبيعي",
  "قراءة أو خرج Voltage Transducer أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors voltage sensor abnormal reading output",
],
[
  "sensor-086",
  "Speed Sensor",
  "Speed Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Speed Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Speed Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors speed sensor not working open",
],
[
  "sensor-087",
  "Speed Sensor",
  "حرارة Speed Sensor ترتفع",
  "حرارة Speed Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Speed Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors speed sensor overheating hot",
],
[
  "sensor-088",
  "Speed Sensor",
  "Speed Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Speed Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors speed sensor intermittent unstable",
],
[
  "sensor-089",
  "Speed Sensor",
  "Speed Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Speed Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors speed sensor loose wrong connection",
],
[
  "sensor-090",
  "Speed Sensor",
  "قراءة أو خرج Speed Sensor مو طبيعي",
  "قراءة أو خرج Speed Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors speed sensor abnormal reading output",
],
[
  "sensor-091",
  "Vibration Sensor",
  "Vibration Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة Vibration Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة Vibration Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors vibration sensor not working open",
],
[
  "sensor-092",
  "Vibration Sensor",
  "حرارة Vibration Sensor ترتفع",
  "حرارة Vibration Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة Vibration Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors vibration sensor overheating hot",
],
[
  "sensor-093",
  "Vibration Sensor",
  "Vibration Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة Vibration Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors vibration sensor intermittent unstable",
],
[
  "sensor-094",
  "Vibration Sensor",
  "Vibration Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ Vibration Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors vibration sensor loose wrong connection",
],
[
  "sensor-095",
  "Vibration Sensor",
  "قراءة أو خرج Vibration Sensor مو طبيعي",
  "قراءة أو خرج Vibration Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors vibration sensor abnormal reading output",
],
[
  "sensor-096",
  "IO-Link Sensor",
  "IO-Link Sensor ما يشتغل أو ما ينفذ وظيفته",
  "وظيفة IO-Link Sensor متوقفة أو مو موجودة بالصورة الطبيعية.",
  "توقف وظيفة IO-Link Sensor",
  [C("تغذية أو إشارة مفقودة", 35), C("المكوّن نفسه متضرر", 30), C("توصيل أو حماية مانعة التشغيل", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["افحص التغذية والحماية والتوصيلات.", "بدل أو صلح الجزء المتضرر بعد العزل."],
  "عالية",
  "الحساسات Sensors io-link sensor not working open",
],
[
  "sensor-097",
  "IO-Link Sensor",
  "حرارة IO-Link Sensor ترتفع",
  "حرارة IO-Link Sensor أعلى من الطبيعي أثناء التشغيل.",
  "ارتفاع حرارة IO-Link Sensor",
  [C("تحميل أعلى من التصميم", 35), C("ربط مقاومته عالية", 30), C("تهوية أو تبريد غير كافي", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["خفف الحمل إذا ممكن وافحص التبريد.", "اعزل المعدة إذا الحرارة أو ريحة الحرك قوية."],
  "حرجة",
  "الحساسات Sensors io-link sensor overheating hot",
],
[
  "sensor-098",
  "IO-Link Sensor",
  "IO-Link Sensor يشتغل أو يقرا بصورة غير مستقرة",
  "أداء أو قراءة IO-Link Sensor تتغير أو تقطع بدون سبب طبيعي.",
  "تشغيل أو قراءة متقطعة",
  [C("ترمنل أو وصلة مرخية", 35), C("تغذية أو إشارة متذبذبة", 30), C("المكوّن بدأ يتدهور", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["راقب الحالة وقت ظهور العطل.", "افحص الربطات والتغذية والإشارة المرتبطة بالمكوّن."],
  "عالية",
  "الحساسات Sensors io-link sensor intermittent unstable",
],
[
  "sensor-099",
  "IO-Link Sensor",
  "IO-Link Sensor بيه ربط أو توصيل مو صحيح",
  "أكو ربط مرخي أو توصيل مو مطابق أو نقطة تلامس ضعيفة مرتبطة بـ IO-Link Sensor.",
  "ربط أو توصيل غير سليم",
  [C("برغي أو ترمنل مرخي", 35), C("توصيل سابق مو مطابق", 30), C("أكسدة أو تلف بنقطة الربط", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["اعزل التغذية قبل إعادة الربط.", "نظف أو بدل اللگ أو الترمنل المتضرر."],
  "حرجة",
  "الحساسات Sensors io-link sensor loose wrong connection",
],
[
  "sensor-100",
  "IO-Link Sensor",
  "قراءة أو خرج IO-Link Sensor مو طبيعي",
  "قراءة أو خرج IO-Link Sensor أعلى أو أقل أو مختلف عن المطلوب.",
  "قراءة أو خرج غير طبيعي",
  [C("إعداد أو معايرة غلط", 35), C("مصدر أو حمل مو طبيعي", 30), C("المكوّن أو الحساس المرتبط بيه متضرر", 20), C("24VDC أو التغذية مو مستقرة", 15)],
  ["قارن القراءة بالمواصفات أو بقياس مرجعي.", "راجع الإعدادات والمكوّن المرتبط بالقياس."],
  "متوسطة",
  "الحساسات Sensors io-link sensor abnormal reading output",
],
];

export const sensorFaults: SensorFault[] = rows.map(
  ([
    id,
    device_ar,
    name_ar,
    description_ar,
    symptom,
    causes,
    solutions,
    severity,
    keywords,
  ]) => {
    const critical = severity === "حرجة";

    return {
      id,
      category_id: null,
      device_ar,
      name_ar,
      description_ar,
      symptoms: [symptom],
      causes,
      tests: [
        {
          test: "الفحص الأولي",
          location: device_ar,
          method: "اعزل المعدة قبل تحريك الحساس أو الدخول لمنطقة الأجزاء المتحركة. إذا الحساس مرتبط بضغط أو حرارة أو مستوى خطر، اعزل طاقة العملية أيضاً.",
          normal:
            "القراءات والحرارة والتوصيلات ضمن الطبيعي، وماكو حرك أو تسريب أو تقطيع أو تلف واضح.",
          faulty:
            "حرارة عالية أو فصل متكرر أو ربط مرخي أو قراءة غير طبيعية يدل على عطل يحتاج فحص قبل التشغيل.",
        },
      ],
      solutions,
      severity,
      safety_warnings: critical
        ? [
            "تنبيه: اعزل كل مصادر الطاقة قبل الصيانة وانتبه من التغذية الراجعة أو التشغيل الأوتوماتيكي.",
            "العمل أو القياس على أجزاء حية أو جهد عالي خليه لفني مؤهل وبمعدات مناسبة.",
          ]
        : [
            "افصل وعزل التغذية قبل الفك أو إعادة الربط.",
            "إذا شفت شرر أو ذوبان أو ريحة حرك أو تشغيل غير متوقع، وقف المعدة وخلي فني يفحصها.",
          ],
      error_code: null,
      keywords,
      next_question_key: null,
    };
  },
);
